<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <EmployeeAttendanceForm
      v-if="!isLoading"
      :employeeData="employeeData"
      :submitName="$t('edit')"
      v-on:addOrUpdateEmployeeAttendance="editAttendanceManuale"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import axios from "axios";
import EmployeeAttendanceForm from "@/components/employeesAttendance/EmployeeAttendanceForm.vue";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "EmployeeAttendanceEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    EmployeeAttendanceForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      attendanceToken: this.$route.params.attendanceToken,
      employeeData: {
        employeeToken: this.$route.params.employeeToken,
        attendedPlaceToken: "",
        attendedBranchToken: "",
        attendanceTypeToken: "",
        employeeSalaryEffectToken: "",
        calculationMethodTypeToken: "",
        employeeSalaryEffectFeeTypeToken: "",
        employeeSalaryEffectValue: "",
        employeeSalaryEffectFromSettingStatus: false,
        attendedDate: "",
        attendedTime: "",
        attendedNote: "",
        departureDate: "",
        departureTime: "",
        departureNote: "",
      },
    };
  },
  methods: {
    async getEmployeesAttendanceDetails() {
      this.isLoading = true;
      try {
        const response = await axios.get(
          `/EmployeesAttendance/GetEmployeesAttendanceDetails?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}&attendanceToken=${this.attendanceToken}`
        );
        if (response.data.status == STATUS.SUCCESS) {
          const theData = response.data.employeesAttendanceData;
          this.employeeData = theData;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async editAttendanceManuale() {
      this.isLoading = true;
      const data = {
        language: this.language,
        userAuthorizeToken: this.userAuthorizeToken,
        employeeToken: this.employeeData.employeeToken,
        attendanceToken: this.attendanceToken,
        attendedPlaceToken: this.employeeData.attendedPlaceToken,
        attendedBranchToken: this.employeeData.attendedBranchToken,
        attendanceTypeToken: this.employeeData.attendanceTypeToken,
        employeeSalaryEffectToken: this.employeeData.employeeSalaryEffectToken,
        calculationMethodTypeToken:
          this.employeeData.calculationMethodTypeToken,
        employeeSalaryEffectFeeTypeToken:
          this.employeeData.employeeSalaryEffectFeeTypeToken,
        employeeSalaryEffectValue: this.employeeData.employeeSalaryEffectValue,
        employeeSalaryEffectFromSettingStatus:
          this.employeeData.employeeSalaryEffectFromSettingStatus,
        attendedPlaceName: this.$t("addedFromManagment"),
        departurePlaceName: this.employeeData.departureDate
          ? this.$t("addedFromManagment")
          : "",
        attendedDate: this.employeeData.attendedDate,
        attendedTime: this.employeeData.attendedTime,
        attendedNote: this.employeeData.attendedNote,
        departureDate: this.employeeData.departureDate,
        departureTime: this.employeeData.departureTime,
        departureNote: this.employeeData.departureNote,
      };

      try {
        const response = await axios.post(
          `/EmployeesAttendance/UpdateAttendance`,
          data
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push(
            "/attendance-employee/" + this.employeeData.employeeToken
          );
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getEmployeesAttendanceDetails();
  },
};
</script>

<style scoped lang="scss"></style>
